/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "payments": {
        "nested": {
          "pushmoney": {
            "nested": {
              "PushMoneyError": {
                "values": {
                  "DEFAULT_PUSH_MONEY_ERROR_ENUM_DO_NOT_USE": 0,
                  "OTHER": 1,
                  "INVALID_ACCOUNT": 2,
                  "CARD_EXPIRED": 3,
                  "CURRENCY_MISMATCH": 4,
                  "BLACKLISTED_ACCOUNT": 5,
                  "INCORRECT_EXPIRATION": 6,
                  "GATEWAY_TIMEOUT": 7,
                  "EXCEEDS_APPROVAL_AMOUNT_LIMIT": 8,
                  "NOT_FULFILL_AML_REQUIREMENT": 9,
                  "EXCEEDS_WITHDRAWAL_FREQUENCY_LIMIT": 10,
                  "ISSUER_UNAVAILABLE": 11,
                  "INSUFFICIENT_FUNDS": 12,
                  "CAPTURE_CARD": 13,
                  "DECLINED_REFER_TO_ISSUER": 14,
                  "COULD_NOT_LOCATE_PAYMENT_FOR_REPLAY": 15,
                  "NO_ROUTE_FOUND": 16,
                  "COMPLIANCE_FAILURE": 17,
                  "AMOUNT_TOO_HIGH": 18,
                  "SUSPECTED_FRAUD": 19,
                  "ACCOUNT_CLOSED": 20,
                  "ACCOUNT_BLOCKED_BY_ISSUER": 21,
                  "PUSH_MONEY_BLOCKED_BY_TRAFFIC_REMEDIATION": 23,
                  "INVALID_MCC": 24,
                  "ILLEGAL_ACTION": 25,
                  "MISSING_COMPANION_DATA": 26,
                  "INVALID_FIELD_DATA": 27,
                  "DO_NOT_HONOR": 28,
                  "RESTRICTED_CARD": 29,
                  "PIN_TRY_LIMIT_EXCEEDED": 30,
                  "DECLINED_REFER_TO_ISSUER_SC": 31,
                  "INVALID_AMOUNT": 32,
                  "TRANSACTION_NOT_ALLOWED_AT_TERMINAL": 33,
                  "INVALID_PIN": 34,
                  "INVALID_INSTRUMENT": 35,
                  "TRANSACTION_NOT_PERMITTED": 36,
                  "ATC_FAILURE": 37,
                  "INVALID_TRANSACTION": 38,
                  "REENTER_TRANSACTION": 39,
                  "INVALID_FORMAT": 40,
                  "SYSTEM_ERROR": 41,
                  "INVALID_MERCHANT": 42,
                  "DUPLICATE_TRANSACTION": 43,
                  "PICK_UP_CARD_FRAUD": 44,
                  "CARD_LOST_OR_STOLEN": 45,
                  "SECURITY_VIOLATION": 46,
                  "BLOCKED_FIRST_USED_OR_SPECIAL_CONDITION": 47,
                  "INVALID_CVV": 48,
                  "INVALID_ROUTING_NUMBER": 49,
                  "CASH_SERVICE_NOT_AVAILABLE": 50,
                  "INACTIVE_CARD": 51,
                  "HONOR_WITH_ID": 52,
                  "PARTIAL_APPROVAL": 53,
                  "NO_ACTION_TAKEN": 54,
                  "UNABLE_TO_LOCATE_RECORD_IN_FILE": 55,
                  "PIN_NOT_CHANGED": 56,
                  "UNSOLICITED_REVERSAL": 57,
                  "ALREADY_REVERSED": 58,
                  "INVALID_AUTH_LIFE_CYCLE": 59,
                  "DECLINE_NO_CASH_BACK": 60,
                  "CRYPTOGRAPHIC_FAILURE": 61,
                  "SURCHARGE_NOT_PERMITTED": 62,
                  "FORCE_STIP": 63,
                  "INELIGIBLE_FOR_RESUBMISSION": 64,
                  "DENIED_PIN_UNBLOCK": 65,
                  "DENIED_PIN_CHANGE": 66,
                  "CARD_AUTHENTICATION_FAILED": 67,
                  "STOP_PAYMENT_ORDER": 68,
                  "DNQ_FOR_VISA_PIN": 69,
                  "ALL_AUTHS_REVOKED": 70,
                  "PICK_UP_CARD": 71,
                  "FORMAT_ERROR": 72,
                  "BANK_NOT_SUPPORTED_BY_SWITCH": 73,
                  "TRANSACTION_NOT_FULFILL_AML_REQUIREMENT": 74,
                  "VIOLATION_OF_LAW": 75,
                  "INVALID_REQUEST": 76,
                  "INTERNAL_ERROR": 77
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.payments?.nested?.pushmoney?.nested?.PushMoneyError) {
  $root.addJSON(jsonData);
}

/**
 * The reason a PushMoney was declined according to the gateway.
 *
 * SOURCE PushMoneyError @ squareup/payments/push_money.proto at 73:1
 */
export const PushMoneyError = $root.lookupEnum('squareup.payments.pushmoney.PushMoneyError').values;